
import { useEffect } from 'react';
import { Outlet, Navigate, data } from 'react-router'
import { API_BASEURL } from 'Var/URLS';

const ProtectedRoutes = ({setloadPre}) => {
  let Auth =  window.sessionStorage.binar
  useEffect(() => {
    if (Auth !== "true") {
      setloadPre(true);
    }
  }, [Auth]);

  return  Auth == 'true' ? <Outlet /> : <Navigate to={'/login'} />
 }

export default ProtectedRoutes